
import React from 'react';
import { TopNavbar } from './ui/TopNavbar';
import { CrmSidebar } from './crm/CrmSidebar'; // Import the new CRM Sidebar
import { useAuth } from '@/contexts/AuthContext';
import { SidebarProvider } from "@/components/ui/sidebar"; // Ensure this path is correct for your shadcn/ui setup

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading application...
      </div>
    );
  }

  return (
    <SidebarProvider collapsedWidth={64}> {/* 64px is 16 in Tailwind units (w-16) */}
      <div className="flex flex-col min-h-screen bg-background">
        <TopNavbar />
        <div className="flex flex-1 w-full"> {/* Added w-full here */}
          {user && <CrmSidebar />} {/* Conditionally render sidebar if user is logged in */}
          <main className="flex-1 overflow-x-hidden"> {/* Added overflow-x-hidden */}
            <div className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Layout;

